export const OVERLAY_IDS = Object.freeze({
  LEGAL_DRAWER: 'legal-drawer',
  MOBILE_NAVIGATION: 'mobile-navigation',
  PRIVACY_SETTINGS: 'privacy-settings'
})
